// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Select from "./Select.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import CountriesFrFRJson from "src/assets/countries-fr-FR.json";
import SubdivisionsFrFRJson from "src/assets/subdivisions-fr-FR.json";

function countries(locale) {
  if (locale === "fr-FR") {
    return CountriesFrFRJson;
  } else {
    return [];
  }
}

function subdivisions(locale) {
  if (locale === "fr-FR") {
    return SubdivisionsFrFRJson;
  } else {
    return [];
  }
}

function countriesAndSubdivisions(locale) {
  return Belt_Array.concatMany([
    countries(locale),
    subdivisions(locale)
  ]).toSorted((current, next) => next.localeCompare(current));
}

function InputCountrySelectField(props) {
  let __required = props.required;
  let __subdivisionsIncluded = props.subdivisionsIncluded;
  let onChange = props.onChange;
  let subdivisionsIncluded = __subdivisionsIncluded !== undefined ? __subdivisionsIncluded : false;
  let required = __required !== undefined ? __required : false;
  let locale = Stdlib_Option.getOr(props.testLocalization, I18n.locale);
  let countriesAndSubdivisions$1 = subdivisionsIncluded ? countriesAndSubdivisions(locale) : countries(locale);
  let items = countriesAndSubdivisions$1.map(country => ({
    TAG: "Option",
    key: country,
    label: country,
    value: country
  }));
  let sections = [{
      items: items
    }];
  return JsxRuntime.jsx(Select.make, {
    label: I18n.t("Country"),
    placeholder: I18n.t("Select a country"),
    preset: {
      NAME: "inputField",
      VAL: {
        required: required,
        errorMessage: props.errorMessage
      }
    },
    sections: sections,
    value: {
      TAG: "Single",
      _0: props.value
    },
    onChange: change => {
      if (change.TAG === "Single") {
        return onChange(change._0);
      }
    }
  });
}

let make = InputCountrySelectField;

export {
  countries,
  subdivisions,
  countriesAndSubdivisions,
  make,
}
/* I18n Not a pure module */
